export const GalleryDivider = ({ ...props }) => (
  <div className="gallery-section-divider" {...props} />
);
